import {useSelector} from "react-redux";
import React, {useContext, useEffect, useState} from "react";
import DrawerContext from "../../../Context/DrawerContext";
import {useForm} from "react-hook-form";
import strings from "../../../localization";
import {Paper} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import SnackbarContext from "../../../Context/SnackbarContext";
import {addContractStatus} from "../../../Services/Finance/ContractStatusService";
import ContractStatusForm from "../../../Components/Forms/Pages/Finance/ContractStatus/ContractStatusForm";

const formRules = {
    'name': {required: {value: true, message: strings.forms.common.thisFieldIsRequired}},
}

const AddContractStatus = (props) => {

    const siteData = useSelector((state) => state.siteData)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setDrawerTitle(strings.pages.finance.contractStatus.addContractStatus.pageTitle);
    });

    const onSubmit = (data) => {

        setShowLoader(true);

        addContractStatus(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ContractStatusForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddContractStatus;